<style scoped lang="scss" type="text/scss">
    .content-container {
        .submit-buttons {
            margin-top: 1rem;
        }
    }
</style>

<template>
    <div class="content-container global-relative">
        <loading-placeholder :loading="requesting"></loading-placeholder>
        <el-table :data="players" stripe border size="small" style="width: 100%;" :max-height="visualAreaHeight">
            <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
            <el-table-column label="晋级状态" width="100" align="center">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.promoted">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="school_name" label="学校名称" align="center" min-width="150"></el-table-column>
            <el-table-column prop="team_name" label="队伍名称" align="center" min-width="150"></el-table-column>
            <el-table-column prop="competition_name" label="所属赛事" align="center" min-width="120"></el-table-column>
        </el-table>

        <div class="submit-buttons">
            <el-button :disabled="isCurrentCompetitionIdNull" type="primary" plain @click="update()"
                       :loading="updateRequesting">
                保存
            </el-button>
            <el-button :disabled="isCurrentCompetitionIdNull" @click="reset()">重置</el-button>
        </div>
    </div>
</template>

<script>
    import {handlePlayers} from '../../../../utils/data-handler';
    import _ from 'lodash';

    export default {
        name: '',
        data () {
            return {
                players: [],
                promotionsMap: {},
                requesting: false,
                updateRequesting: false
            };
        },
        computed: {
            currentCompetitionId () {
                return this.$store.state.competition.currentMainCompetitionId;
            },
            isCurrentCompetitionIdNull () {
                return this.currentCompetitionId === null;
            },
            visualAreaHeight () {
                return this.$store.getters['layout/adminCompetitionPromotionVisualAreaHeight'];
            }
        },
        watch: {
            currentCompetitionId: {
                immediate: true,
                handler () {
                    this.reload();
                }
            }
        },
        methods: {
            reload () {
                const id = this.currentCompetitionId;
                if (id === null || id === undefined) return;
                this.requesting = true;
                Promise.all([
                    this.loadSubPlayers(id), this.loadPromotions(id)
                ]).then(_ => {
                    this.requesting = false;
                    this.decoratePlayerPromotedStatus();
                }).catch(_ => {
                    this.requesting = false;
                });
            },
            loadSubPlayers (id) {
                return this.$store.dispatch('player/loadSubPlayersByCompetitionId', {
                    competition_id: id
                }).then(response => {
                    const players = handlePlayers(response.data);
                    players.forEach(player => {
                        this.$set(player, 'promoted', false);
                    });
                    this.players = players;
                });
            },
            loadPromotions (id) {
                return this.$store.dispatch('competition/loadCompetitionPromotions', {
                    id: id
                }).then(response => {
                    const promotions = response.data;
                    const promotionsMap = {};
                    promotions.forEach(promotion => {
                        promotionsMap[promotion['player_id']] = true;
                    });
                    this.promotionsMap = promotionsMap;
                });
            },
            decoratePlayerPromotedStatus () {
                this.players.forEach(player => {
                    player.promoted = this.promotionsMap[player.id] === true;
                });
            },
            update () {
                const promotedPlayerIds = _.map(_.filter(this.players, item => item.promoted === true), 'id');
                this.$normalRequest('competition/assignCompetitionPromotions', {
                    id: this.currentCompetitionId,
                    players: promotedPlayerIds
                }, '晋级状态更新成功', true, this, 'updateRequesting').then(_ => {
                    this.reload();
                });
            },
            reset () {
                this.decoratePlayerPromotedStatus();
            }
        }
    };
</script>
